import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UtilsFormule from "../../utils/UtilsFormule";
import { Snackbar, TextField } from "@material-ui/core";
import DataTableTicketShop from "../../ui/DataTableTicketShop";
import OrderService from "../../services/PosService/OrderService";
import withLoader from "../../components/layouts/WithLoader";
import DataTableTicketPayement from "../../ui/DataTableTicketPayement";
import CardPayementTickets from "../../components/cardBox/CardPayementTickets";
import DataTableTicketCredit from "../../ui/DataTableTicketCredit";
const TicketShop = ({ startLoading, stopLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [availableTicket, setAvailableTicket] = useState([]);
  const [availableTicketPayement, setAvailableTicketPayement] = useState([]);
  const [credits, setCredits] = useState([]);
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [showTable, setShowTable] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  //statistique
  const [payementTotal, setPayementTotal] = useState(0);
  const [caTotal, setCaTotal] = useState(0);
  // const idDetailsTicketMagasin = localStorage.getItem("idDetailsTicketMagasin");
  /*for pagination*/
  // const [currentPage, setCurrentPage] = useState(1);
  // const [itemsPerPage, setItemsPerPage] = useState(10);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalElements, setTotalElements] = useState(0);
  //payement total card
  const [espece, setEspece] = useState(0);
  const [cheque, setCheque] = useState(0);
  const [card, setcard] = useState(0);
  const [virement, setvirement] = useState(0);
  const [carteCadeau, setCarteCadeau] = useState(0);
  //btnClear
  const [btnClear, setBtnClear] = useState(false);

  useEffect(() => {
    onGetTickets();
    onGetPayements();
  }, []);

  const onGetTickets = () => {
    startLoading();
    OrderService.getTicketShopDetails(
      localStorage.getItem("idDetailsTicketMagasin"),
      dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableTicket(response?.data?.success);
          setCredits(response?.data?.credits)
          setPayementTotal(response?.data?.totalPayment);
          setCaTotal(response?.data?.chiffreAffaires);
          //totalPayement
          setEspece(response?.data?.espece);
          setcard(response?.data?.card);
          setvirement(response?.data?.virement);
          setCarteCadeau(response?.data?.carteCadeau);
          setCheque(response?.data?.cheque);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onGetTicketsFilter = (dateBegin, dateEnd) => {
    startLoading();
    OrderService.getTicketShopDetails(
      localStorage.getItem("idDetailsTicketMagasin"),
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableTicket(response?.data?.success);
          setPayementTotal(response?.data?.totalPayment);
          setCaTotal(response?.data?.chiffreAffaires);
          //totalPayement
          setEspece(response?.data?.espece);
          setcard(response?.data?.card);
          setvirement(response?.data?.virement);
          setCarteCadeau(response?.data?.carteCadeau);
          setCheque(response?.data?.cheque);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onGetPayements = () => {
    startLoading();
    OrderService.getAllPayementsTicketsShop(
      localStorage.getItem("idDetailsTicketMagasin"),
      dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableTicketPayement(response?.data?.success);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onGetPayementsFilter = (dateBegin, dateEnd) => {
    startLoading();
    OrderService.getAllPayementsTicketsShop(
      localStorage.getItem("idDetailsTicketMagasin"),
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableTicketPayement(response?.data?.success);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onGetTicketsByFiltersHandler = () => {
    // setShowTable(true);
    onGetTickets();
    onGetPayements();
    setBtnClear(true);
  };
  const onClearGetTicketsByFiltersHandler = () => {
    setBtnClear(false);
    setDateBegin("any");
    setDateEnd("any");
    onGetTicketsFilter("any", "any");
    onGetPayementsFilter("any", "any");
  };

  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value);
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value);
  };

  const filterTableTicket = () => {
    if (availableTicket && availableTicket?.length > 0) {
      return <DataTableTicketShop tickets={availableTicket} />;
    }
  };
  const filterTableTicketPayement = () => {
    if (availableTicketPayement && availableTicketPayement?.length > 0) {
      return (
        <DataTableTicketPayement payementTickets={availableTicketPayement} />
      );
    }
  };
  const filterTableTicketCredit = () => {
    if (credits && credits?.length > 0) {
      return (
        <DataTableTicketCredit credits={credits} />
      );
    }
  };
  const cardStatistique = () => {
    return (
      <>
        <section class="content">
          <div className="container-fluid">
            <div className="row">
              {caTotal !== null && (
                <div className="col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-sack-dollar"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Chiffre d'affaire</span>
                      <span className="info-box-number">{caTotal}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description"></span>
                    </div>
                  </div>
                </div>
              )}
              {payementTotal !== null && (
                <div className="col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-hand-holding-dollar"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Paiement</span>{" "}
                      <span className="info-box-number">{payementTotal}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </>
    );
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      {/* <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  {" "}
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Les devis d'achat
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section> */}
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">Les Tickets de caisse du magasin  {localStorage.getItem("nameDetailsTicketMagasin")}</h5>
              {/* {(userRole.includes("ADMIN") ||
                userRole.includes("PURCHASING_MANAGER")) && (
                <button
                  class="btn btn-dark  float-right"
                  onClick={onAddDevisHandler}
                >
                  {" "}
                  <i class="fas fa-plus"></i>
                </button>
              )} */}
              <br />
              <div className="row">
                <p>
                  <small>
                    Initialement, il y avait des tickets pour ce jour{" "}
                    <b>{UtilsFormule.formatDate(new Date())}</b>.
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="date"
                          // label="Date Début"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="date"
                          // label="Date fin"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="row">
                    {btnClear && (
                      <div className="col-sm-6 text-center">
                        <button
                          className="btn btn-dark"
                          onClick={onClearGetTicketsByFiltersHandler}
                        >
                          Annuler Filter
                        </button>
                      </div>
                    )}
                    <div
                      className={
                        !btnClear
                          ? "col-sm-12 text-center"
                          : "col-sm-6 text-center"
                      }
                    >
                      <button
                        className="btn btn-dark"
                        onClick={onGetTicketsByFiltersHandler}
                      >
                        Valider le choix
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {cardStatistique()}
      {/* {payementTotal > 0 && ( */}
      <CardPayementTickets
        espece={espece}
        virement={virement}
        carteCadeau={carteCadeau}
        card={card}
        cheque={cheque}
      />
      {/* )} */}
      <section class="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">{filterTableTicketPayement()}</div>
          </div>
        </div>
      </section>
      <section class="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">{filterTableTicketCredit()}</div>
          </div>
        </div>
      </section>


      <section class="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">{filterTableTicket()}</div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default withLoader(TicketShop);
